import {
    ActionService,
    ConfigurationService,
    EntityData, field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";

export class StripeConnectionTokenRefreshRequestData extends EntityData<StripeConnectionTokenRefreshRequestData> {
    @field deviceSecret: string;
    @field deviceSerialNumber: string;
}

/**
 * Service called from the App Device to retrieve a new Stripe Connection Token to authenticate with an App Device.
 * The token secret is retrieved from the server and passed back to the app device.
 */
@Injectable({providedIn: "root"})
export class StripeConnectionTokenRefreshService extends ActionService {

    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- StripeConnectionTokenRefreshService");

        super(http, nameSpace, "stripe-connection-token-refresh", configService, useAsync, actionNames);
    }
}
